import script from "./EditEmailTemplatesBox.vue?vue&type=script&setup=true&lang=js"
export * from "./EditEmailTemplatesBox.vue?vue&type=script&setup=true&lang=js"

import "./EditEmailTemplatesBox.vue?vue&type=style&index=0&id=f14a3db2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f14a3db2"]])

export default __exports__